import { Fragment, useEffect, useState } from "react";
import styles from "./Statement.module.css";
import store from "../../Store/Store";
import axios from "axios";
import config from "../../config/config";
import { observer } from "mobx-react";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";

const Statement = observer(() => {
  const [yearOptions, setYearOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedmonth] = useState("");
  const [gotResponse, setGotResponse] = useState(false);
  const [data, setData] = useState();
  const [Clicked, setClicked] = useState(false);
  const [ShowSuccess, setShowSuccess] = useState(false);
  const [ClickedStmt, setClickedStmt] = useState("");
  const [Error, setError] = useState(false);
  const [ErrorMsg, setErrorMsg] = useState({});
  // {
  //   Title: "Network issue",
  //   message: "Poor or lost internet connection during download",
  // }    ErrorMsg example

  let monthOptions = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const generateYearOptions = (startYear) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= startYear; year--) {
      years.push(year);
    }
    return years;
  };

  useEffect(() => {
    setSelectedYear("");
    setGotResponse(false);
    const startYear = 2025;
    setYearOptions(generateYearOptions(startYear));
  }, [store.refresh]);

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
      } else {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  };
  const GetStatementsData = (year, month) => {
    setData([]);
    setGotResponse(false);
    if (!year) {
      console.log("trow Error no Year Selected");
      return;
    }
    if (!month) {
      console.log("trow Error no month Selected");
      return;
    }
    const monthNumber = monthOptions.indexOf(month) + 1;
    const formattedMonth = String(monthNumber).padStart(2, "0");
    const obj = {
      ledger_label: store.Company_Id,
      year: year,
      month: formattedMonth,
    };

    try {
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_monthly_spend_daily`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };
      console.log("payload", obj);

      // setData(testData); //delete in prod
      // setGotResponse(true); //delete in prod
      axios
        .request(payload)
        .then((response) => {
          setGotResponse(true);
          console.log("response.data", response.data.data);

          if (response.data.data.length > 0) {
            setData(response.data.data);
          } else {
            setData([]);
          }
        })
        .catch((err) => {
          console.log("Error fetching data:", err);
        });
    } catch (err) {
      console.log("Error:", err);
    }
  };

  const handleDownloadStatement = async (month, url) => {
    setSelectedmonth(month);
    console.log(`Downloading report for ${month} ${selectedYear}`);

    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `statement-${month}-${selectedYear}.pdf`; // optional filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  useEffect(() => {
    (async () => {
      if (!Clicked && gotResponse) {
        setShowSuccess(true);
        await new Promise((resolve) => setTimeout(resolve, 5000));
        setShowSuccess(false);
      }
    })();
  }, [Clicked]);
  return (
    <Fragment>
      {/* <div className={styles.NoteContainer}>
        <div className={styles.NoteContent}>
          <span className={styles.Bold}>Note:</span> The UTR for the wallet
          loads will not match because of an issue at Pine Labs PPI escrow
          account. We are working on updating the system to reflect the correct
          UTR. Please note that the amount and date will match.
        </div>
      </div> */}
      <div className={styles.Container}>
        <div className={styles.FilterContainer}>
          <div className={styles.FilterContainer1}>
            <select
              className={styles.Filter}
              value={selectedYear}
              onChange={async (e) => {
                setSelectedYear(e.target.value);
                GetStatementsData(e.target.value, selectedMonth);
              }}
            >
              <option value="" disabled>
                Select Year
              </option>
              {yearOptions.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            <select
              className={styles.Filter}
              value={selectedMonth}
              onChange={(e) => {
                setSelectedmonth(e.target.value);
                GetStatementsData(selectedYear, e.target.value);
              }}
            >
              <option value="" disabled>
                Select Month
              </option>
              {monthOptions.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>
            <div className={styles.AlertContainer}>
              Note:{" "}
              <span className={styles.AlertSpan}>
                You can download statements only for the dates on which your
                employees spent with CUPI.
              </span>
            </div>
          </div>
          {/* {ShowSuccess && !Error && (
            <div className={styles.SuccessAlertContainer}>
              <img
                className={styles.filterLinesIcon}
                alt=""
                src="/check-circle.svg"
              />
              <span>Statements downloaded successfully!</span>
            </div>
          )} */}
          {Error && (
            <div className={styles.ErrorAlertContainer}>
              <div>{ErrorMsg.Title}</div>
              <span className={styles.ErrorAlertSpan}>{ErrorMsg.message}!</span>
            </div>
          )}
        </div>
        <div className={styles.tableContainer}>
          {console.log("selectedYear", selectedYear)}

          {selectedYear && gotResponse && data.length > 0 ? (
            <table className={styles.ReportTable}>
              <tbody className={styles.TableBody}>
                {console.log("data", data)}

                {data?.map((res) => (
                  <tr key={res.statement_name} className={styles.TableRow}>
                    {console.log("res", res)}
                    <td className={styles.TableMonth}>{res?.statement_name}</td>
                    <td className={styles.TableButton}>
                      {Clicked && ClickedStmt == res?.statement_name ? (
                        <button className={styles.GenerateButtonDis}>
                          <img
                            className={styles.filterLinesIcon}
                            alt=""
                            src="/Blue_Download_Icon.svg"
                          />
                          <span className={styles.GenerateButtonText}>
                            Downloading...
                          </span>
                        </button>
                      ) : (
                        <button
                          className={styles.GenerateButton}
                          onClick={async () => {
                            // setClicked(true);
                            setClickedStmt(res.statement_name);
                            await handleDownloadStatement(
                              res.statement_name,
                              res.url,
                            );
                            console.log("sytem Clicked 2 sec", Clicked);
                            // await new Promise((resolve) =>
                            //   setTimeout(resolve, 1500),
                            // );
                            // setClicked(false);
                          }}
                        >
                          <img
                            className={styles.filterLinesIcon}
                            alt=""
                            src="/Blue_Download_Icon.svg"
                          />
                          <span className={styles.GenerateButtonText}>
                            Download
                          </span>
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className={styles.NoTableData}>
              No statements found. Please select a valid year and month to view your
              statement.
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
});

export default Statement;
